import React from 'react';
import { HandHeartIcon } from 'lucide-react';
import { useProto } from '../../contexts/PrototypeContext';
import { programInfo } from '../../data/program';
import { volunteerOptions } from '../../data/registration';
import { formatMoney } from '../../utils/format';
import { CartSummary } from './CartSummary';
import { StepNotice } from './StepNotice';
import { Annotation } from '../shared/Annotation';
export function CartStep({
  device
}: {
  device: 'mobile' | 'desktop';
}) {
  const {
    state,
    cart,
    actions
  } = useProto();
  const desktop = device === 'desktop';
  const choice = volunteerOptions.find(o => o.id === state.choice);
  return <div className={desktop ? 'mx-auto grid max-w-[1080px] grid-cols-[minmax(0,1fr)_360px] items-start gap-10 px-10 py-12' : 'space-y-4 px-4 py-5'} data-id="element-201" data-mp="1vnqqvuh6eec2">
      <div className="min-w-0 space-y-4 font-i9" data-id="element-202" data-mp="24oewq1wf18dv">
        <h1 className={`font-bold text-i9-ink ${desktop ? 'text-[26px]' : 'text-[22px]'}`} data-id="element-203" data-mp="24lkd2cl87rli">Your cart</h1>
        <StepNotice data-id="element-204" data-mp="29knfrqdqhlqb" />

        <section aria-labelledby="cart-program" className="rounded-lg border border-i9-line" data-id="element-205" data-mp="1omltmrftskf2">
          <header className="border-b border-i9-line px-4 py-3" data-id="element-206" data-mp="1kla2uil7tt5a">
            <h2 id="cart-program" className="text-[15px] font-bold text-i9-ink" data-id="element-207" data-mp="1kjyxiec4gdc2">{programInfo.name}</h2>
            <p className="text-[12.5px] text-i9-muted" data-id="element-208" data-mp="1fmfgj6o1hmgf">{programInfo.franchise} · {programInfo.season}</p>
          </header>
          <ul className="divide-y divide-i9-line" data-id="element-209" data-mp="28auv5s39e2r8">
            {cart.items.map(item => <li key={item.id} className="flex items-center gap-3 px-4 py-3" data-id="element-210" data-mp="28cnvkpna3qqs">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-i9-navy text-[13px] font-bold text-white" aria-hidden="true" data-id="element-211" data-mp="23cjizaphrg5u">
                  {item.label.split(' ').map(p => p[0]).join('')}
                </span>
                <div className="min-w-0 flex-1" data-id="element-212" data-mp="2r1m0mik4l90c">
                  <p className="text-[15px] font-semibold text-i9-ink" data-id="element-213" data-mp="2r3f8u2ae01ag">{item.label}</p>
                  <p className="text-[12.5px] text-i9-muted" data-id="element-214" data-mp="2m9b1hhx7lr8u">{item.detail}</p>
                </div>
                <span className="text-[15px] font-semibold tabular-nums text-i9-ink" data-id="element-215" data-mp="kdvgiorwd9qy">{formatMoney(item.amount)}</span>
              </li>)}
          </ul>
        </section>

        <section aria-label="Volunteer selection" className="flex items-center gap-3 rounded-lg border border-i9-line px-4 py-3" data-id="element-216" data-mp="amhcc3p03lrh">
          <HandHeartIcon className="h-5 w-5 shrink-0 text-i9-steel" aria-hidden="true" data-id="element-217" data-mp="fk90qnqfspqx" />
          <div className="min-w-0 flex-1" data-id="element-218" data-mp="nrrq35pzn7j">
            <p className="text-[12.5px] text-i9-muted" data-id="element-219" data-mp="5op767zci35c">Volunteer selection</p>
            <p className="text-[14px] font-semibold text-i9-ink" data-id="element-220" data-mp="3ntsgk4wch1bk">{choice ? choice.short : 'Not selected'}</p>
          </div>
          <button type="button" onClick={() => actions.goToStep('volunteer')} className="text-[14px] font-semibold text-i9-steel underline-offset-2 transition-colors hover:text-i9-steelDark hover:underline" data-id="element-221" data-mp="3ssdj4az2jx36">
            Change
          </button>
        </section>

        <Annotation kind="rule" title="One discount per volunteering customer, per program" data-id="element-222" data-mp="214nxu898zz71">
          Applies once even with two children in this program. Multi-child discount and member credit still apply. Full legal terms are not repeated here.
        </Annotation>
      </div>
      <CartSummary device={device} data-id="element-223" data-mp="257aoi5u6ne2n" />
    </div>;
}